// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  RejectedMint,
  MintRequest,
} from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import {
  MintRequest as MintRequest3Step,
  RejectedMint as RejectedMint3Step,
} from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Mint';
import { RequestState, RequestType, RowNew } from '../components/Table/types';
import TemplateContract from './TemplateContract';

export type MintTemplateUnion =
  | TemplateContract<MintRequest>
  | TemplateContract<MintRequest3Step>
  | TemplateContract<RejectedMint>
  | TemplateContract<RejectedMint3Step>;

const genericMintMapper = (
  contract: MintTemplateUnion,
  requestType: RequestType,
  requestState: RequestState,
  isThreeStep?: boolean,
) => {
  const commonFields = {
    contractId: contract.contractId,
    createdAt: contract.createdAt,
    amount: contract.payload.mint.amount,
    reference: contract.payload.mint.reference,
    holder: contract.payload.mint.holder,
    sender: contract.payload.mint.holder,
    requestType,
    requestState,
    isThreeStep,
  };

  const flattened: RowNew = {
    ...commonFields,
    receiver: '',
    reason: '',
    operator: '',
    provider: '',
    instrumentId: '',
    registrar: '',
    holdingLabel: '',
  };

  if ('operator' in contract.payload.mint) {
    flattened.operator = contract.payload.mint.operator;
  }
  if ('operator' in contract.payload) {
    flattened.operator = contract.payload.operator;
  }
  if ('provider' in contract.payload.mint) {
    flattened.provider = contract.payload.mint.provider;
  }
  if ('provider' in contract.payload) {
    flattened.provider = contract.payload.provider;
  }

  if ('reason' in contract) {
    flattened.reason = contract.reason as string;
  }
  if ('reason' in contract.payload) {
    flattened.reason = contract.payload.reason;
  }
  if ('instrumentId' in contract.payload.mint) {
    flattened.instrumentId = contract.payload.mint.instrumentId.id;
    flattened.registrar = contract.payload.mint.instrumentId.admin;
    flattened.receiver = contract.payload.mint.instrumentId.admin;
  }
  if ('instrumentIdentifier' in contract.payload.mint) {
    flattened.instrumentId = contract.payload.mint.instrumentIdentifier.id;
    flattened.registrar = contract.payload.mint.instrumentIdentifier.source;
    flattened.receiver = contract.payload.mint.instrumentIdentifier.source;
  }
  if ('holdingLabel' in contract.payload) {
    flattened.holdingLabel = contract.payload.holdingLabel;
  }

  return flattened;
};

export const flattenMints = (
  contracts: MintTemplateUnion[],
  requestState: RequestState,
  isThreeStep?: boolean,
) => {
  return contracts.map((c) => genericMintMapper(c, RequestType.Mint, requestState, isThreeStep));
};
